import React from 'react'
import Footer from './Footer'
import Header from './Header'

function Base(prop) {
  return (
    <>
    <Header/>
    {prop.children}
    <Footer/>
    </>
  )
}

export default Base